// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cfd8eeee","977":"36e618bc"}[chunkId] + ".chunk.js";
};